"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeSliderSingular = void 0;
const react_1 = __importDefault(require("react"));
const RangeSliderSingular_styles_1 = require("./RangeSliderSingular.styles");
const RangeSliderSingular = (props) => {
    const { value, min, max, onChange, disabled, step } = props;
    const newVal = ((value - min) * 100) / (max - min); //https://css-tricks.com/value-bubbles-for-range-inputs/
    const magicNumber = `calc(${newVal}% + (${8 - newVal * 0.15}px))`; //https://codepen.io/chriscoyier/pen/eYNQyPe
    return (react_1.default.createElement(RangeSliderSingular_styles_1.Wrapper, null,
        react_1.default.createElement(RangeSliderSingular_styles_1.RangeValue, null, min),
        react_1.default.createElement(RangeSliderSingular_styles_1.RangeSliderWrapper, null,
            react_1.default.createElement(RangeSliderSingular_styles_1.Slider, { type: "range", min: min, max: max, value: value, step: step, onChange: onChange, disabled: disabled }),
            react_1.default.createElement(RangeSliderSingular_styles_1.Bubble, { disabled: disabled, position: magicNumber }, value)),
        react_1.default.createElement(RangeSliderSingular_styles_1.RangeValue, null, max)));
};
exports.RangeSliderSingular = RangeSliderSingular;
exports.default = exports.RangeSliderSingular;
//# sourceMappingURL=RangeSliderSingular.js.map